import { useContext } from 'react'
import { DevtoolsContext } from './context'

export function useDevtools() {
  const context = useContext(DevtoolsContext)
  if (context === undefined) {
    throw new Error('useDevtools must be used within a DevtoolsProvider')
  }
  return context
}
